import React, { useState } from 'react'
import { Box, Tooltip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpen } from '@fortawesome/pro-duotone-svg-icons/faEnvelopeOpen'
import { faEnvelope } from '@fortawesome/pro-duotone-svg-icons/faEnvelope'
import { LoadingDefault } from '@/shared/ui/loading'
import { StyledButton } from '@/shared/ui/buttons'
import { MessagesReadstatusProps } from './types'

const MessagesReadstatus: React.FC<MessagesReadstatusProps> = ({
    kedo,
    checked,
    readStatus,
    onClose,
}) => {
    const [setRead, setSetRead] = useState(false)
    const [setUnread, setSetUnread] = useState(false)
    const [dossier] = useState({}) // kept but not used, same as original

    const markAsRead = () => {
        if (!checked) return

        const selectedItems = checked
        const url = kedo.api().getMessageEndpoint() + '/read'

        setSetRead(true)
        kedo.api()
            .post(url, { messages: selectedItems })
            .then(() => {
                setSetRead(false)
                onClose()
            })
    }

    const markAsUnread = () => {
        if (!checked) return

        const url = kedo.api().getMessageEndpoint() + '/unread'
        setSetUnread(true)
        kedo.api()
            .post(url, { messages: checked })
            .then(() => {
                setSetUnread(false)
                onClose()
            })
    }

    if (!readStatus) {
        return (
            <Tooltip title={kedo.t('Mark as read')} arrow>
                <StyledButton color="secondary" onClick={markAsRead}>
                    {setRead ? (
                        <LoadingDefault />
                    ) : (
                        <Box>
                            <FontAwesomeIcon icon={faEnvelopeOpen} />
                            &nbsp; {kedo.t('Mark as read')}
                        </Box>
                    )}
                </StyledButton>
            </Tooltip>
        )
    } else {
        return (
            <Tooltip title={kedo.t('Mark as unread')} arrow>
                <StyledButton color="secondary" onClick={markAsUnread}>
                    {setUnread ? (
                        <LoadingDefault />
                    ) : (
                        <Box>
                            <FontAwesomeIcon icon={faEnvelope} />
                            &nbsp; {kedo.t('Mark as unread')}
                        </Box>
                    )}
                </StyledButton>
            </Tooltip>
        )
    }
}

export default MessagesReadstatus
